import { Component, ViewContainerRef, OnInit } from '@angular/core';
import { ConfigService } from './config/config.service';
import { BlockUIService } from './shared/services/blockui.service';
import { RolesPermissionsService } from './shared/services/rolespermissions.service';
//import { Idle, DEFAULT_INTERRUPTSOURCES } from 'ng2-idle';
import { SessionService } from './shared/services/session.service';
import { VersionCheckService } from './shared/services/version-check.service';
// import { IState, initialState, authenticationValidationReducer } from './Session/authenticationvalidation';


@Component({
    selector: 'viracor-app',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    appVersion: string = "";
    copyrightYear: number = 0;
    footerMessage: string = "";
    headerImageSource: string = '';
    privacyPolicyLink = "";
    private viewContainerRef: ViewContainerRef;
    loading: Boolean;
    loadingFromProxy: boolean = false;
    public notificationsOptions = {
        position: ['bottom', 'right'],
        timeOut: 5000,
        preventDuplicates: true,
        preventLastDuplicates: 'visible'
    };
    display: boolean = false;
    baseUrl : string = "";
    frequency ;
    constructor(viewContainerRef: ViewContainerRef, 
        private blockUIService: BlockUIService, private configService: ConfigService,
        private sessionService: SessionService, private versionCheckService: VersionCheckService) {

       this.baseUrl =  location.protocol + "//" + location.host;
       
        // session.configureStore(authenticationValidationReducer, initialState);
    }
    ngOnInit() {

        var apiurl =  this.baseUrl + '/assets/config/version.json';

      //  this.frequency = this.configService.getUiConfiguration('reloadFrequency');
        this.frequency = "10000";
        this.versionCheckService.initVersionCheck(apiurl,parseInt(this.frequency))
        
        this.blockUIService.blockUIEvent.subscribe(event => this.blockUnBlockUI(event));

        this.blockUIService.blockUIEvent.emit({
            value: false
        });
        this.appVersion = this.configService.get("AppVersion");
        this.copyrightYear = this.configService.getCurrentYear();
        this.footerMessage = this.configService.get("footerMessage");
        this.privacyPolicyLink = this.configService.get('privacyPolicyLink');
        this.headerImageSource = this.configService.getUiConfiguration('HeaderImageSource');
        //this is added to accomodate proxy login page. We should not show this footer when the loading.
        if (this.sessionService.getItem('uname') != null && this.sessionService.getItem('upwd') != null) {
            this.loadingFromProxy = true;
        }
    }
    private blockUnBlockUI(event) {
        this.loading = event.value;
    }

    openPrivacyPolicyPage() {
        window.open(this.privacyPolicyLink);
    }

     openTermsandConditionPage() {
    this.display = true;
    }
    closeDialog() {
        this.display = false;

    }
}
